import React, { Component } from 'react'
import Approvals from '../../../../components/Main/Dashboard/Approvals/Approvals'
import { message } from 'antd'
import { pick } from 'lodash'
import ApprovalsApi from '../../../../api/Approvals'

class ApprovalsCont extends Component {
  state = {
    list: [],
    claim: {},
    approving: false,
    direct: true,
    Claim: false,
  }

  componentDidMount() {
    this.fetch()
  }

  api = new ApprovalsApi()
  fetch = async (options = {}) => {
    try {
      this.setState({
        fetching: true,
      })
      let direct = options.direct !== undefined ? options.direct : this.state.direct
      const list = await this.api.list({ direct })
      this.setState({
        list,
        fetching: false,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  approve = async (doc) => {
    try {
      this.setState({
        fetching: true,
      })
      await this.api.approve(pick(doc, ['_key', 'type', '_id', '_rev']))
      this.setState({
        fetching: false,
      })
      this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  onChangeSwitch = (checked) => {
    this.setState({
      direct: checked,
    })
    this.fetch({ direct: checked })
  }

  toggleModal = (visible, type, doc) => {
    this.setState({ [`visible${type}`]: visible, [type.toLowerCase()]: doc })
  }

  render() {
    return (
      <Approvals
        {...this.state}
        {...pick(this, ['fetch', 'toggleModal', 'approve', 'onChangeSwitch'])}
      />
    )
  }
}

ApprovalsCont.propTypes = {}
ApprovalsCont.defaultProps = {}

export default ApprovalsCont
